// Muestra el logo del tenant si tiene uno configurado; si no ("Sin imagen" en
// Personaliza tu Tienda), muestra el nombre de la tienda como texto en su lugar.
export default function TenantBrand({ tenant, imgClassName = "h-11 w-auto object-contain", textClassName = "font-head text-xl font-extrabold uppercase tracking-tight text-current" }) {
  if (tenant.logo_url) {
    return <img src={tenant.logo_url} alt={tenant.name} className={imgClassName} />;
  }
  return <span className={textClassName}>{tenant.name}</span>;
}
